// src/Apollo/index.ts

import client from './client';

export default client;
